// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__syDCc","vLegacy":"SelectSecondary_vLegacy__3vu9u","error":"SelectSecondary_error__245ib","disabled":"SelectSecondary_disabled__27xGN"};